import { render, staticRenderFns } from "./SliderLabels.vue?vue&type=template&id=49e94589&scoped=true&"
import script from "./SliderLabels.vue?vue&type=script&lang=js&"
export * from "./SliderLabels.vue?vue&type=script&lang=js&"
import style0 from "./SliderLabels.vue?vue&type=style&index=0&id=49e94589&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e94589",
  null
  
)

export default component.exports